// Module
var code = "<form-dynamique nature=\"'multikeyvalue'\" field=\"$ctrl.elementsField\" model=\"$ctrl.model\" model-name=\"$ctrl.AdditionnalInfo\" principal=\"true\" niveau-visibilite=\"undefined\"> </form-dynamique> ";
// Exports
module.exports = code;